import { log } from './log';
import { isWx } from './base';
import invokeClient from './invokeClient';
const setWeChat = ({ title, desc, link, imgUrl }) => {
    const business = 2;
    const url = window.location.href.split('#')[0];
    fetch(`/cgi-op/api/v1/wechat/getJsSdkConfig?business=${business}&url=${encodeURIComponent(url)}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then((res) => res.json())
        .then((res) => {
        const data = res.data;
        const wx = window.wx;
        wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
                'updateAppMessageShareData',
                'updateTimelineShareData', // 分享给朋友
            ],
        });
        wx.ready(() => {
            // 分享给朋友
            wx.updateAppMessageShareData({
                title,
                desc,
                link,
                imgUrl,
                success: () => {
                    // 设置成功
                },
            });
            // 分享到朋友圈
            wx.updateTimelineShareData({
                title,
                link,
                imgUrl,
                success: () => {
                    // 设置成功
                },
            });
        });
        wx.error((err) => {
            console.log('配置失败:', err);
        });
    })
        .catch((err) => {
        console.log('获取签名失败:', err);
    });
};
let shareOption = {};
// 这个函数供客户端主动调用
// 如果此时分享数据为空，则进行填充
export const getShareData = () => {
    log('客户端获取分享数据陈成功');
    shareOption.title = shareOption.title || document.title;
    shareOption.description =
        shareOption.description || '你的朋友分享了一些好东西给你';
    shareOption.url = shareOption.url || window.location.href;
    // 默认值为米家的logo
    shareOption.imageUrl =
        shareOption.imageUrl ||
            'http://cdn.cnbj0.fds.api.mi-img.com/miio.files/commonfile_png_31e7e094020bfbb0262dab94b1ab84f2.png';
    return shareOption;
};
export const setShareData = ({ title, description, url, imageUrl, }) => {
    var _a;
    shareOption.title = title;
    shareOption.description = description;
    shareOption.url = url;
    shareOption.imageUrl = imageUrl;
    log('设置分享数据', shareOption);
    if (isWx) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
        (_a = document.querySelector('head')) === null || _a === void 0 ? void 0 : _a.appendChild(script);
        script.onload = function () {
            const shareData = getShareData();
            setWeChat({
                title: shareData.title,
                desc: shareData.description,
                link: shareData.url,
                imgUrl: shareData.imageUrl,
            });
        };
    }
};
export const triggerShare = (params = {}) => {
    return invokeClient.invoke({
        functionName: 'triggerShare',
        params: JSON.stringify(params),
    });
};
//# sourceMappingURL=data:application/json;base64,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